{
  "name": "gb-webapp-yez",
  "version": "1.0.2",
  "scripts": {
    "ng": "ng",
    "start": "set NODE_OPTIONS=--max-old-space-size=4096 && nx serve t1",
    "build": "nx build",
    "build:lib": "nx build gb-app",
    "serve": "nx serve",
    "dev:ssr": "nx run t1:serve",
    "serve:ssr": "node dist/t1/server/server.mjs",
    "build:ssr": "nx build t1 --configuration=development",
    "build:ssr:qa": "nx build t1 --configuration=qa",
    "build:ssr:staging": "nx build t1 --configuration=staging",
    "build:ssr:prod-eu": "nx build t1 --configuration=prod-eu",
    "build:ssr:prod-us": "nx build t1 --configuration=prod-us",
    "watch": "nx build t1 --watch --configuration development",
    "test": "nx test",
    "test:lib": "nx test gb-app",
    "test:all": "nx run-many --target=test --all",
    "test:affected": "nx affected:test",
    "test:watch": "nx test t1 --watch",
    "test:coverage": "nx test t1 --code-coverage",
    "test:coverage:watch": "nx test t1 --code-coverage --watch",
    "test:single-run": "nx test t1 --browsers ChromeHeadless --single-run",
    "test:ci": "nx test --project t1 --browsers ChromeHeadless --code-coverage --watch=false",
    "test:debug": "nx test t1 --browsers Chrome --single-run=false --watch=false",
    "lint": "nx lint",
    "lint:lib": "nx lint gb-app",
    "lint:all": "nx run-many --target=lint --all",
    "lint:affected": "nx affected:lint",
    "lint:fix": "nx lint t1 --fix",
    "format": "prettier --write \"apps/**/*.{ts,js,html,css,scss,json}\" \"libs/**/*.{ts,js,html,css,scss,json}\"",
    "format:check": "prettier --check \"apps/**/*.{ts,js,html,css,scss,json}\" \"libs/**/*.{ts,js,html,css,scss,json}\"",
    "format:fix": "prettier --write \"apps/**/*.{ts,js,html,css,scss,json}\" \"libs/**/*.{ts,js,html,css,scss,json}\" && nx lint t1 --fix",
    "theme:build": "npx ts-node scripts/build-theme.ts build",
    "theme:build:metrics": "npx ts-node scripts/build-theme-enhanced.ts build --metrics",
    "theme:serve": "npx ts-node scripts/build-theme.ts serve",
    "theme:serve-ssr": "npx ts-node scripts/build-theme.ts serve-ssr",
    "theme:watch": "npx ts-node scripts/watch-theme.ts",
    "theme:test": "npx ts-node scripts/build-theme.ts test",
    "theme:lint": "npx ts-node scripts/build-theme.ts lint",
    "theme:create": "npx ts-node scripts/create-theme.ts",
    "theme:metrics": "npx ts-node scripts/metrics-report.ts",
    "theme:metrics:clear": "npx ts-node scripts/metrics-report.ts --clear",
    "build:all": "npx ts-node scripts/build-all-themes.ts",
    "build:all:dev": "npx ts-node scripts/build-all-themes.ts development",
    "build:all:qa": "npx ts-node scripts/build-all-themes.ts qa",
    "build:all:staging": "npx ts-node scripts/build-all-themes.ts staging",
    "build:all:prod-eu": "npx ts-node scripts/build-all-themes.ts prod-eu",
    "build:all:prod-us": "npx ts-node scripts/build-all-themes.ts prod-us",
    "test:scripts": "jest scripts/__tests__",
    "create-theme": "nx run-script create-theme"
  },
  "private": true,
  "dependencies": {
    "@angular/common": "^19.2.0",
    "@angular/compiler": "^19.2.0",
    "@angular/core": "^19.2.0",
    "@angular/forms": "^19.2.0",
    "@angular/platform-browser": "^19.2.0",
    "@angular/platform-browser-dynamic": "^19.2.0",
    "@angular/platform-server": "^19.2.0",
    "@angular/router": "^19.2.0",
    "@angular/ssr": "^19.2.9",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@stripe/stripe-js": "^7.8.0",
    "axios": "^1.11.0",
    "bootstrap": "^5.3.7",
    "class-transformer": "^0.5.1",
    "class-validator": "^0.14.2",
    "compression": "^1.8.0",
    "dotenv": "^17.2.1",
    "express": "^4.18.2",
    "fuse.js": "^7.1.0",
    "inversify": "^7.6.1",
    "ioredis": "^5.6.1",
    "jwt-decode": "^4.0.0",
    "qrcode": "^1.5.4",
    "rxjs": "~7.8.0",
    "search-text-highlight": "^2.0.8",
    "sitemap": "^9.0.0",
    "socket.io-client": "^4.8.1",
    "swiper": "^11.2.10",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.9",
    "@angular-devkit/core": "^19.2.9",
    "@angular-devkit/schematics": "^19.2.9",
    "@angular-eslint/builder": "20.1.1",
    "@angular-eslint/eslint-plugin": "20.1.1",
    "@angular-eslint/eslint-plugin-template": "20.1.1",
    "@angular-eslint/schematics": "20.1.1",
    "@angular-eslint/template-parser": "20.1.1",
    "@angular/cli": "^19.2.9",
    "@angular/compiler-cli": "^19.2.0",
    "@nx/angular": "21.6.4",
    "@nx/jest": "^22.0.2",
    "@nx/workspace": "21.6.4",
    "@schematics/angular": "^19.2.9",
    "@types/bootstrap": "^5.2.10",
    "@types/compression": "^1.8.1",
    "@types/express": "^4.17.17",
    "@types/jasmine": "~5.1.0",
    "@types/jest": "^30.0.0",
    "@types/node": "^18.18.0",
    "@types/qrcode": "^1.5.5",
    "@types/redis": "^4.0.11",
    "@typescript-eslint/eslint-plugin": "7.11.0",
    "@typescript-eslint/parser": "7.11.0",
    "eslint": "8.57.1",
    "eslint-config-prettier": "^10.1.5",
    "eslint-plugin-prettier": "^5.5.0",
    "jasmine-core": "~5.6.0",
    "jest": "^29.7.0",
    "jest-preset-angular": "^14.4.2",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "nx": "^21.6.4",
    "prettier": "^3.6.0",
    "prettier-eslint": "^16.4.2",
    "ts-jest": "^29.4.5",
    "ts-node": "^10.9.2",
    "typescript": "~5.7.2"
  }
}
